import React from 'react';

import { camelCaseEmptyStringRecursive } from '../../../services/utils';

const ItemsOtherRequest = props => {
  const { item } = camelCaseEmptyStringRecursive(props);

  return (
    <div className="info-box">
      <p className="info">
        <span>Tipo de Solicitud:</span> {item.otherRequestTypeName}
      </p>
      <p className="info">
        <span>Fecha:</span> {item.endDate ? `${item.startDate} al ${item.endDate}` : item.startDate}
      </p>
      <p className="info">
        <span>Adicional:</span> {item.additional}
      </p>
      <p className="info">
        <span>Motivo:</span> {item.reason}
      </p>
    </div>
  );
};

export default ItemsOtherRequest;
